import React, {memo} from "react";
import PropTypes from "prop-types";
import {
  ClickAwayListener,
  Slide,
  ListItemButton,
  ListItemText,
  MenuList,
  Paper,
  Popper,
  useTheme,
} from "@mui/material";
import {useSidebarStyles} from "./sidebarStyles";

export const SidebarOverlay = memo(({open, children, anchorEl, parentText, onClose}) => {
  const {classes} = useSidebarStyles();
  const theme = useTheme();

  return (
    <Popper
      open={open}
      anchorEl={anchorEl}
      placement="right-start"
      transition
      disablePortal
      popperOptions={{strategy: "fixed"}}
      style={{zIndex: theme.zIndex.drawer + 2}}
    >
      {({TransitionProps}) => (
        <div style={{overflow: "hidden"}}>
          <Slide {...TransitionProps} direction="right">
            <Paper square className={`${classes.overlay} sidebar-submenu`}>
              <ClickAwayListener onClickAway={onClose}>
                <div
                  onBlur={(e) => {
                    if (!e.currentTarget.contains(e.relatedTarget)) {
                      onClose();
                    }
                  }}
                >
                  {parentText && (
                    <ListItemButton
                      className={classes.parentTitle}
                      disableRipple
                      role="presentation"
                    >
                      <ListItemText
                        primary={parentText}
                        primaryTypographyProps={{variant: "body2"}}
                      />
                    </ListItemButton>
                  )}
                  <MenuList>{children}</MenuList>
                </div>
              </ClickAwayListener>
            </Paper>
          </Slide>
        </div>
      )}
    </Popper>
  );
});

SidebarOverlay.displayName = "SidebarOverlay";

SidebarOverlay.propTypes = {
  open: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
  anchorEl: PropTypes.object,
  parentText: PropTypes.string,
  onClose: PropTypes.func.isRequired,
};
